"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBSearchAdvancedFilter;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                           * Global components
                                                                                                                                                                                                                                                                                                                                                                                           * By Juan Rodrigo <jponceflores@svb.com> (www.svb.com)
                                                                                                                                                                                                                                                                                                                                                                                           * Summary
                                                                                                                                                                                                                                                                                                                                                                                           * This component renders a SVB search advanced filter
                                                                                                                                                                                                                                                                                                                                                                                           */
/**
 * SVBSearchAdvancedFilter
 * @param {string} [header = "Filters"] - Text to be displayed as the filter header
 * @param {string} [buttonText = "Clear all"] - Text to be displayed in the button
 * @param {string} [subHeader = "Categories"] - Text to be displayed as the filter subheader
 * @param {object[]} dataArray - Array of objects to be filtered
 * @param {function} setFilteredDataArray - Function to set the filtered array of objects
 * @param {function} [buttonOnClick] - Function to be excecuted when clicking the button
 * @param {number} [filterWidth = 2] - Width of the container (in bootstrap numbers 1 to 12)
 * @param {string} [extraClasses = ""] - Extra classes to be added to the button element
 * @returns JSX element
 */
function SVBSearchAdvancedFilter(props) {
  var _typeCheck, _typeCheck2, _typeCheck3;
  // Prop error handling
  let componentError = false;
  const typeCheck = function typeCheck(prop, types) {
    let extraValidations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!types.includes(typeof prop)) componentError = true;
    if (extraValidations && typeof prop !== "undefined") {
      for (let validation of extraValidations) {
        if (!validation(prop)) componentError = true;
      }
    }
    return prop;
  };
  const isBootstrapWidth = width => !(width > 12 || width < 1 || !Number.isInteger(width));
  const isArrayOfObjects = list => {
    if (Array.isArray(list) && list.length) {
      for (let element of list) {
        if (typeof element !== 'object' || Array.isArray(element) || element === null) return false;
      }
      return true;
    } else return false;
  };
  const header = (_typeCheck = typeCheck(props.header, ["string", "undefined"])) !== null && _typeCheck !== void 0 ? _typeCheck : "Filters";
  const buttonText = (_typeCheck2 = typeCheck(props.buttonText, ["string", "undefined"])) !== null && _typeCheck2 !== void 0 ? _typeCheck2 : "Clear all";
  const subHeader = (_typeCheck3 = typeCheck(props.subHeader, ["string", "undefined"])) !== null && _typeCheck3 !== void 0 ? _typeCheck3 : "Categories";
  const dataArray = typeCheck(props.dataArray, ["object"], [isArrayOfObjects]);
  const [categories, setCategories] = (0, _react.useState)({});
  const [categoriesFilled, setCategoriesFilled] = (0, _react.useState)(false);
  const setFilteredDataArray = typeCheck(props.setFilteredDataArray, ["function"]);
  const buttonOnClick = typeCheck(props.buttonOnClick, ["function", "undefined"]) || clearCategories;
  const filterWidth = typeCheck(props.filterWidth, ["number", "undefined"], [isBootstrapWidth]) || 2;
  const extraClasses = typeCheck(props.extraClasses, ["string", "undefined"]) || "";

  // Prop error check
  if (componentError) return /*#__PURE__*/_react.default.createElement("p", null, "Invalid prop sent, check console for prop type errors.");
  (0, _react.useEffect)(() => {
    let set = new Set();
    dataArray.forEach(element => {
      set.add(element.tag);
    });
    const newCategories = {};
    set.forEach(element => {
      newCategories[element] = false;
    });
    setCategoriesFilled(true);
    setCategories(newCategories);
  }, [dataArray]);
  (0, _react.useEffect)(() => {
    if (categoriesFilled) {
      const selectedCategories = Object.keys(categories).filter(category => categories[category]);
      const filteredData = dataArray.filter(element => selectedCategories.includes(element.tag));
      setFilteredDataArray(filteredData);
    }
  }, [categories, categoriesFilled]);
  function clearCategories() {
    const clearedCategories = {};
    Object.keys(categories).forEach(category => clearedCategories[category] = false);
    setCategories(clearedCategories);
  }
  ;
  const handleOnChange = e => {
    setCategories(_objectSpread(_objectSpread({}, categories), {}, {
      [e.target.value]: e.target.checked
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-advanced-filter col-".concat(filterWidth, " ").concat(extraClasses)
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "search-advanced-filter-header"
  }, header), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: buttonOnClick,
    className: "svb-button svb-button_small svb-button_primary-default svb-button_type-text"
  }, buttonText), /*#__PURE__*/_react.default.createElement("p", null, subHeader), Object.keys(categories).map(category => /*#__PURE__*/_react.default.createElement("span", {
    key: "".concat(category, "-category-span")
  }, /*#__PURE__*/_react.default.createElement("input", {
    onChange: handleOnChange,
    type: "checkbox",
    className: "form-check-input me-1",
    name: "filter-categories",
    id: category,
    value: category,
    checked: categories[category]
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: category
  }, category), /*#__PURE__*/_react.default.createElement("br", null))));
}
;
SVBSearchAdvancedFilter.propTypes = {
  header: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  subHeader: _propTypes.default.string,
  dataArray: function dataArray(props, propName) {
    if (Array.isArray(props[propName]) && props[propName].length) {
      for (let element of props[propName]) {
        if (typeof element !== 'object' || Array.isArray(element) || element === null) return new Error("Invalid ".concat(propName, " prop - ").concat(propName, " prop must be a non empty array of objects"));
      }
    } else return new Error("Invalid ".concat(propName, " prop - ").concat(propName, " prop must be a non empty array of objects"));
  },
  setFilteredDataArray: _propTypes.default.func.isRequired,
  buttonOnClick: _propTypes.default.func,
  filterWidth: function filterWidth(props, propName) {
    if (typeof props[propName] !== "undefined") {
      if (typeof props[propName] !== "number" || props[propName] < 1 || props[propName] > 12 || !Number.isInteger(props[propName])) {
        return new Error("Invalid ".concat(propName, " prop - ").concat(propName, " prop must be an integer between 1 and 12"));
      }
    }
  },
  extraClasses: _propTypes.default.string
};